import script from "./SfxCurrentUserDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxCurrentUserDisplay.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import TouchHold from 'quasar/src/directives/touch-hold/TouchHold.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QAvatar,QIcon,QBtn});qInstall(script, 'directives', {TouchHold});
